var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "hkl-delete-icon" }, [
    _c(
      "i",
      _vm._g(
        _vm._b(
          { staticClass: "fa fa-times fa-lg pointer" },
          "i",
          _vm.$attrs,
          false
        ),
        _vm.$listeners
      )
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }